import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { SellerUpdateDocumentModel } from './../../../../models/archive/seller-update-document.model';
import { SellerModel } from './../../../../models/archive/seller.model';
import { SellerService } from './../../../../services/archive/seller.service';

@Component({
  selector: 'app-update-document-seller',
  templateUrl: './update-document-seller.component.html',
  styleUrls: ['./update-document-seller.component.scss'],
  standalone: false
})
export class UpdateDocumentSellerComponent implements OnInit {

  changeDocument: boolean = false;
  formSellerUpdate: FormGroup = new FormGroup({});
  sellerModel: SellerModel = new SellerModel();
  subscription: Subscription;

  constructor(public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    @Optional() private ref: DynamicDialogRef,
    private sellerService: SellerService,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm(new SellerModel());
  }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.subscription = input$?.subscribe((inputs: any) => {
      this.sellerModel = inputs.sellerContract;
      if (this.sellerModel) {
        this.validateForm(this.sellerModel);
      } else {
        console.warn('transporterModel undefined');
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.changeDocument) {
      data.params = { reload: true, sellerModel: this.sellerModel };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  async getDigitVerification() {
    const document = this.formSellerUpdate.get("document")?.value;
    if (document == '') {
      this.formSellerUpdate.controls["digitVerification"].patchValue(null);
      this.toastHandlerService.showToast(
        'error',
        `El documento ingresado no es válido.`
      );
      return;
    }
    try {
      const response = await firstValueFrom(this.sellerService.getDigitVerification(document));
      this.formSellerUpdate.controls["digitVerification"].patchValue(response);
    } catch (error) {
      this.formSellerUpdate.controls["digitVerification"].patchValue(null);
      console.error('Error al buscar el digíto de verificación.', error);
    }
  }

  async send() {
    this.validateFormControls();
    if (this.formSellerUpdate.valid) {
      try {
        const modelSeller = this.formSellerUpdate.getRawValue() as SellerUpdateDocumentModel;
        this.sellerModel = await firstValueFrom(this.sellerService.updateSellerDocument(modelSeller));
        this.validateForm(this.sellerModel);
        this.changeDocument = true;
        this.close();
        this.toastHandlerService.showToast(
          'success',
          `El documento del vendedor fue modificado exitosamente.`
        );
      } catch (error) {
        console.error('Error al actualizar el documento.', error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      sellerId: {
        required: 'El campo Vendedor es obligatorio.',
        min: 'Debe seleccionar un Vendedor válido.'
      },
      document: {
        required: 'El campo Documento es obligatorio.',
        maxlength: 'El Documento no puede tener más de 15 caracteres.'
      },
      digitVerification: {
        required: 'El campo Dígito de Verificación es obligatorio.',
        min: 'El Dígito de Verificación no puede ser menor que 0.',
        max: 'El Dígito de Verificación no puede ser mayor que 9.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formSellerUpdate.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm(sellerModel: SellerModel) {
    this.formSellerUpdate = this.formBuilder.group({
      sellerId: [sellerModel.sellerId, [Validators.required, Validators.min(1)]],
      document: [sellerModel.document, [Validators.required, Validators.maxLength(15)]],
      digitVerification: [sellerModel.digitVerification, [Validators.required, Validators.min(0),
      Validators.max(9)]]
    });
    setTimeout(() => this.formSellerUpdate.controls["digitVerification"].disable());
  }

  validateFormControls() {
    Object.keys(this.formSellerUpdate.controls).forEach((key) => {
      const control = this.formSellerUpdate.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
